import { SaveIcon } from "lucide-react";

import { JobForm } from "./JobForm";

import { useUpdateJob } from "@/hooks/mutations/useUpdateJob";
import { Job } from "@/types";

export const JobEdit = ({
  className,
  job,
}: {
  className?: string;
  job: Job;
}) => {
  const { mutate: updateJob, isPending, isError } = useUpdateJob();

  return (
    <JobForm
      className={className}
      job={job}
      mutationFn={updateJob}
      isPending={isPending}
      isError={isError}
      submitButtonIcon={<SaveIcon className="h-4 w-4" />}
      submitButtonText="Update job"
    />
  );
};
